module.exports = __webpack_public_path__ + "img/SAHA.d622d212.png";